import { useEffect, useRef } from 'react';

export default function useScrollAnimation() {
  const observerRef = useRef(null);

  useEffect(() => {
    // Disconnect any previous observer
    if (observerRef.current) observerRef.current.disconnect();

    observerRef.current = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            // Use requestAnimationFrame for butter-smooth class toggling
            requestAnimationFrame(() => {
              entry.target.classList.add('visible');
            });
            // Stop observing once animated in
            observerRef.current.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    // Small delay to ensure DOM is ready after render
    const timer = setTimeout(() => {
      const els = document.querySelectorAll('.fade-up, .fade-left, .fade-right, .scale-up');
      els.forEach((el) => observerRef.current?.observe(el));
    }, 50);

    return () => {
      clearTimeout(timer);
      observerRef.current?.disconnect();
    };
  }, []);
}
